import { export_json_to_excel } from "@/utils/excel/Export2Excel.js";
import printJS from "print-js";
/**
 * @description: 检测字符串
 */
export function checkStr(str, type) {
  // 常用正则验证，注意type大小写
  switch (type) {
    case "phone": // 手机号码
      return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(str);
    case "tel": // 座机
      return /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/.test(str);
    case "card": // 身份证
      return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(str);
    case "pwd": // 密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线
      return /^[a-zA-Z]\w{5,17}$/.test(str);
    case "pwd2": // 密码以大小写字母、数字
      return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(str);
    case "postal": // 邮政编码
      return /[1-9]\d{5}(?!\d)/.test(str);
    case "QQ": // QQ号
      return /^[1-9][0-9]{4,9}$/.test(str);
    case "email": // 邮箱
      return /^[\w-]+(.[\w-]+)*@[\w-]+(.[\w-]+)+$/.test(str);
    case "money": // 金额(小数点2位)
      return /^\d*(?:.\d{0,2})?$/.test(str);
    case "IP": // IP
      return /((?:(?:25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d?\d))/.test(
        str
      );
    case "date": // 日期时间
      return (
        /^(\d{4})-(\d{2})-(\d{2}) (\d{2})(?::\d{2}|:(\d{2}):(\d{2}))$/.test(
          str
        ) || /^(\d{4})-(\d{2})-(\d{2})$/.test(str)
      );
    case "number": // 数字
      return /^[0-9]$/.test(str);
    case "english": // 英文
      return /^[a-zA-Z]+$/.test(str);
    case "name": // 中文-英文
      return /^[\u4e00-\u9fa5a-zA-Z]{1}$/.test(str);
    case "chinese": // 中文
      return /^[\u4E00-\u9FA5]+$/.test(str);
    case "lower": // 小写
      return /^[a-z]+$/.test(str);
    case "upper": // 大写
      return /^[A-Z]+$/.test(str);
    case "HTML": // HTML标记
      return /<("[^"]*"|'[^']*'|[^'">])*>/.test(str);
    case "letterNumber": // 大写
      return /^[A-Za-z0-9]+$/.test(str);
    case "integer": // 整数
      return /^-?[1-9]\d*$/.test(str);
    default:
      return true;
  }
}
/**
 * @description: 处理导出数据
 */
export function exportExcel(title, tableData, propertiesConfig, label, value) {
  let label_ = label || "displayName";
  let value_ = value || "field";
  let header = [];
  let datas = [];
  propertiesConfig.length &&
    propertiesConfig.forEach((el) => {
      header.push(el[label_]);
    });

  tableData.length &&
    tableData.forEach((item) => {
      let arr = [];
      propertiesConfig.forEach((el) => {
        arr.push(item[el[value_]]);
      });

      datas.push(arr);
    });

  export_json_to_excel(header, datas, title);
}
/**
 * @description: 打印
 */
export function print(titile, tableData, propertiesConfig) {
  const style = "@page {margin:0 10mm};  color:pink";
  printJS({
    printable: tableData,
    properties: propertiesConfig,
    type: "json",
    headerStyle: "font-size:2px;font-weight:600;padding:15px 0 10px 0;", //标题设置
    gridHeaderStyle:
      "font-size:6px;font-weight:400;border: 1px solid #ccc;padding:5px;text-align:center;",
    gridStyle:
      "font-size:1px;font-weight:200;border: 1px solid #ccc;padding:3px;text-align:center;",
    style,
    header: titile,
  });
}
/**
 * @description: 判断是否是手机
 */
export function isMobile() {
  // 判断是否为移动端
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}
export function isWeiXin() {
  // 判断是否为微信
  let ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}
export function getQueryString(name) {
  //企业微信授权获取code问题解决办法
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  const result = window.location.search.substring(1).match(reg);
  if (result != null) {
    return decodeURIComponent(result[2]);
  }
  return null;
}

export function getPayStatusColors() {
  return ["", "#0072F6", "#59E8E9", "#FFB900", "#EB5774", "#cccccc", "#FF743F"];
}
export function getPayStatusOptions() {
  return ["", "空闲", "充电中", "充完占用", "故障", "离线", "预约占用"];
}

export function getWorkStatusColors() {
  return [
    "",
    "#ffba00",
    "#ffba00",
    "#FF7F50",
    "#FF6633",
    "#C0C4CC",
    "#C0C4CC",
    "#C0C4CC",
  ];
}
export function getHotelWorkStatusOptions() {
  return ["", "", "待确认", "待使用", "使用中", "已使用", "已过期", "已取消"];
}
export function getTicketStatusOptions() {
  return ["", "", "", "待使用", "使用中", "已使用", "已过期", "已取消"];
}
export function getActiveStatusOptions() {
  return ["", "待生效", "", "待使用", "使用中", "已使用", "已过期", "已取消"];
}
export function getAgentWorkStatusColors() {
  return [
    "",
    "#ffba00", //待生效
    "",
    "#FF7F50", //待售卖
    "#FF6633", //售卖中
    "#67C23A", //已售完
    "#C0C4CC", //已过期
    "#C0C4CC", //已取消
    "#C0C4CC",
  ];
}
export function getPassStatusColors() {
  return ["", "#FF3333", "#ffba00", "#67C23A"];
}


/**
 * @export
 * 时间转格式时间
 * @param {*} time 时间
 * @param {string} [fmt='YYYY-MM-DD'] 
 * @param {Boolean}  isHMS  // 是否展示时分秒
 */
export function timeFormat(time, isHMS = false) {
	if (!time) return ''
	var date = new Date(time); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
	var Y = date.getFullYear() + '-';
	var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
	var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
	var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
	var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
	// + h + m + s

	if (isHMS) {
		return Y + M + D + h + m + s;
	} else {
		return Y + M + D;
	}
}

/**
 * 数组去重
 */
export const unique = (array) => {
	var arr = []; //创建新数组
	for (var i = 0; i < array.length; i++) { //遍历当前数组
		if (arr.indexOf(array[i]) === -1) { //如果等于-1，那么也是就是新数组中没有一项和当前数组一样
			arr.push(array[i])
		}
	}
	return arr;
}

/**
 * 对象转为字符串
 * @param {String,Array } arrayData 数组对象
 * @param {String} key 对象key
*/
export function objToStirng(arrayData,key) {
	let str = ''
	for (let i = 0; i < arrayData.length; i++) {
		//最后一条数据
		let lastLength = arrayData.length - 1;
		//如果不是最后一条数据加上,
		if (i !== lastLength) {
			str += arrayData[i][key] + ','
		} else {
			str += arrayData[lastLength][key]
		}
	}
	return str;

}